/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAdminSystemSpecialityGroupsGet$Params {
  systemOrgFhirId?: string;
}

export function apiAdminSystemSpecialityGroupsGet(http: HttpClient, rootUrl: string, params?: ApiAdminSystemSpecialityGroupsGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminSystemSpecialityGroupsGet.PATH, 'get');
  if (params) {
    rb.query('systemOrgFhirId', params.systemOrgFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as HealthFindrStrictHttpResponse<void>;
    })
  );
}

apiAdminSystemSpecialityGroupsGet.PATH = '/api/Admin/system-speciality-groups';
